import React from 'react';

const DollarIcon = ({
  width = 32,
  height = 32,
  color = '#F6A723',
  strokeColor = '#FFFFFF',
  strokeWidth = 1.67,
  className,
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect width="32" height="32" rx="6.72" fill={color} />
      <path
        d="M24.3327 16.0003C24.3327 20.6027 20.6017 24.3337 15.9993 24.3337C11.397 24.3337 7.66602 20.6027 7.66602 16.0003C7.66602 11.398 11.397 7.66699 15.9993 7.66699C20.6017 7.66699 24.3327 11.398 24.3327 16.0003Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M18.2578 14.3846C18.1753 13.749 17.4455 12.7222 16.1333 12.7221C14.6087 12.7221 13.9671 13.5665 13.837 13.9887C13.6339 14.5535 13.6745 15.7146 15.4616 15.8412C17.6955 15.9995 18.5904 16.2632 18.4766 17.6303C18.3627 18.9974 17.1174 19.2928 16.1333 19.2611C15.1492 19.2295 13.539 18.7774 13.4766 17.5614M15.9772 11.832V12.7252M15.9772 19.2529V20.1653"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DollarIcon;
